// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';
import { designTokens } from '../theme/designTokens';

/**
 * Isolated Networks logo.
 *
 * Variants (see frontend/DESIGN.md):
 *  - reverse  — dark backgrounds (default product chrome)
 *  - full     — light backgrounds
 *  - oneColor — single-color / print
 *  - mark     — compact geometric SVG
 */
const SOURCES = {
  reverse: designTokens.logo.reverse,
  full: designTokens.logo.full,
  oneColor: designTokens.logo.oneColor,
  mark: designTokens.logo.mark,
};

export default function KinLogo({
  variant = 'reverse',
  height = 48,
  width = 'auto',
  maxWidth = 220,
  alt = 'Isolated Networks',
  style,
  sx,
  ...rest
}) {
  const h = typeof height === 'number' ? `${height}px` : height;
  const w = typeof width === 'number' ? `${width}px` : width;
  const mw = typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth;

  return (
    <img
      src={SOURCES[variant] || SOURCES.reverse}
      alt={alt}
      draggable={false}
      style={{
        display: 'block',
        height: h,
        width: w,
        maxWidth: mw,
        objectFit: 'contain',
        ...(variant === 'mark'
          ? { filter: 'drop-shadow(0 2px 8px rgba(33, 30, 113, 0.67))' }
          : null),
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}
